import { render, staticRenderFns } from "./WorkoutCard.vue?vue&type=template&id=621c897e&scoped=true&"
import script from "./WorkoutCard.vue?vue&type=script&lang=js&"
export * from "./WorkoutCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutCard.vue?vue&type=style&index=0&id=621c897e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621c897e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
